import { Marker, InfoWindow } from "@react-google-maps/api";
import { useState } from "react";

import HNSColors from "../../../../../ui library/HNSColors";
import { getIconURL } from "../../helper/functions";

import CustomMarkerInfo from "./CustomMarkerInfo";

export default function CustomMarker({ data = [] }) {
  const [activeInfoWindow, setActiveInfoWindow] = useState(null);

  const handleMouseOver = (index) => {
    setActiveInfoWindow(index);
  };

  const handleMouseOut = () => {
    setActiveInfoWindow(null);
  };

  return (
    <>
      {data.map((item, index) => {
        const lat = Number(item?.address?.latitude);
        const lng = Number(item?.address?.longitude);
        if (isNaN(lat) || isNaN(lng)) {
          return null;
        }

        const offset = 0.00001;
        const iconUrl = getIconURL(item);

        return (
          <Marker
            key={item?.id || index}
            position={{
              lat: lat + index * offset,
              lng: lng + index * offset,
            }}
            options={{
              icon: {
                url: iconUrl,
                scaledSize: new window.google.maps.Size(24, 24),
              },
            }}
            onMouseOver={() => handleMouseOver(index)}
            onMouseOut={handleMouseOut}
          >
            {activeInfoWindow === index && (
              <InfoWindow
                position={{
                  lat: lat + index * offset,
                  lng: lng + index * offset,
                }}
                options={{
                  enableEventPropagation: true,
                  disableAutoPan: true,
                  pixelOffset: new window.google.maps.Size(0, -20),
                }}
              >
                <div
                  style={{
                    backgroundColor: HNSColors.neutrals[900],
                    padding: "6px 8px",
                    borderRadius: "8px",
                  }}
                >
                  <CustomMarkerInfo data={item} />
                </div>
              </InfoWindow>
            )}
          </Marker>
        );
      })}
    </>
  );
}
